<template>
    <div class="public_container department_add_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

            </ReturnNavBar>
        </div>
        <div class="mobile_container" v-loading="loading">
            <van-form
                ref="customForm"
                :rules="customFormRules"
                error-message-align="right"
                input-align="right"
                label-width="10em"
                :show-error-message="false"
                scroll-to-error
            >
                <van-field
                    required
                    v-model="formData.didText"
                    name="didText"
                    label="变更部门"
                    placeholder="请选择"
                    is-link
                    readonly
                    @click="handleClickSelect('did')"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                </van-field>
            </van-form>
        </div>
        <!--级联选择-->
        <van-popup
            :style="{ height: '480px' }"
            position="bottom"
            round
            v-if="showCascaderPicker"
            v-model="showCascaderPicker"
        >
            <van-cascader
                :field-names="cascaderFieldNames"
                :options="cascaderOptions"
                :title="'选择部门'"
                :closeable="false"
                @change="handleClickCascaderChange"
                active-color="#2990FF"
                v-model="cascaderValue"
            >
                <template slot="title">
                    <div class="custom_cascader_title">
                        <div class="custom_cascader_title_arrow" @click="handleCascaderClose">
                            <van-icon name="arrow-left" />
                        </div>
                        <p>选择部门</p>
                        <span @click="handleClickCascaderConfirm">确定</span>
                    </div>
                </template>
            </van-cascader>
        </van-popup>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
    </div>
</template>

<script>
import { GetCompanyDepartmentList, UpdateUserDepartment } from "@/api";
import { EventBus } from '@/utils/eventBus';
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "MPersonnelDepartmentChange",
    components: { ReturnNavBar },
    data() {
        return {
            pid: "",
            pName: "",
            loading: false,
            btnDisabled: false,
            formData: {
                userIds: [],
                did: "",
                didText: "",
            },
            customFormRules: {},
            showCascaderPicker: false,
            cascaderOptions: [],
            cascaderFieldNames: {
                text: "department_name",
                value: "id",
                children: "children",
            },
            cascaderValue: "",
            selectCascaderData: {},
        };
    },
    created() {
        if (this.$route.query) {
            // this.formData.did = this.$route.query.did;
            // this.formData.didText = this.$route.query.pName;
            this.formData.userIds = this.$route.query.user_ids || [];
        }
        // let localStorageData = localStorage.getItem("MPersonnelDepartmentChangeList");
        // if (localStorageData) {
        //     localStorageData = JSON.parse(localStorageData);
        //     this.formData.userIds = localStorageData;
        // }
        this.getDepartmentList();
    },
    methods: {
        handleClickSelect(type) {
            this.showCascaderPicker = true;
        },
        handleClickCascaderChange({ selectedOptions }) {
            this.selectCascaderData = selectedOptions[selectedOptions.length - 1]
        },
        // 部门选择确认
        handleClickCascaderConfirm() {
            const data = JSON.parse(JSON.stringify(this.selectCascaderData)) || {}
            this.formData.did = data.id
            this.formData.didText = data.department_name
            this.handleCascaderClose()
        },
        // 选择框关闭
        handleCascaderClose() {
            this.showCascaderPicker = false
            this.selectCascaderData = {}
        },
        //获取部门列表
        getDepartmentList() {
            GetCompanyDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.cascaderOptions = res.data.departments || [];
                } else {
                    this.$toast(res.message);
                }
            });
        },
        handleClickConfirm() {
            this.$refs.customForm.validate().then(() => {
                console.log("confirm");
                this.btnDisabled = true;
                const params = {
                    department_id: this.formData.did,
                    user_ids: this.formData.userIds,
                };
                UpdateUserDepartment(params).then((res) => {
                    if (res.code === 200) {
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                EventBus.$emit('personnelAddUpdated');
                                this.$router.go(-1);
                            },
                        });
                    } else {
                        this.$toast({
                            message: res.message,
                            type: "fail",
                        });
                    }
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.department_add_wrap {
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
    ::v-deep {
        .van-cascader__header {
            .van-cascader__title {
                width: 100%;
            }
        }
        .custom_cascader_title {
            display: flex;
            justify-content: space-between;
            .custom_cascader_title_arrow {
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                .van-icon {
                    color: #666666;
                }
            }
            & > p {
                font-size: 16px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(51, 51, 51, 1);
            }
            & > span {
                font-size: 16px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 23.17px;
                color: rgba(41, 144, 240, 1);
            }
        }
    }
}
</style>
